export default "__VITE_ASSET__a1908768__"